import React from "react";
import PenIcon from "@/assets/pen.png";
import { SummaryBeneficiary } from "@/types/summary";

interface BeneficiariesSectionProps {
  data: SummaryBeneficiary[];
  onEdit: () => void;
}

const BeneficiariesSection: React.FC<BeneficiariesSectionProps> = ({
  data,
  onEdit,
}) => {
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  };

  return (
    <div className="border-b-[1px] border-[#E2E2E2] p-[20px]">
      <div className="flex justify-between items-center mb-[16px]">
        <h3 className="text-[1.125rem]">Beneficiaries</h3>
        <button
          onClick={onEdit}
          className="text-[#00ADAC] hover:text-[#008281] text-[1.125rem] cursor-pointer border-none bg-transparent flex items-center gap-1"
        >
          <img src={PenIcon} className="w-[18px] h-[18px]" alt="Edit" />
          Edit
        </button>
      </div>

      <div className="space-y-[12px]">
        {data.map((beneficiary) => (
          <div key={beneficiary.minorAccountID}>
            <div className="flex justify-between items-start">
              <div>
                <p className="text-[16px]">
                  {beneficiary.firstName} {beneficiary.lastName}
                </p>
                <p className="text-[1rem] text-[#8B8B8B]">
                  {formatDate(beneficiary.dateOfBirth)}
                </p>
                <p className="text-[1rem] text-[#8B8B8B]">
                  {beneficiary.relationship}
                </p>
              </div>
            </div>
          </div>
        ))}

        {data.length === 0 && (
          <div className="text-center text-[#8B8B8B]">
            <p>No beneficiaries added yet.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default BeneficiariesSection;
